import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import { StriimIconButton } from "@striim/striim-ui-v2";

const AI_GRADIENT =
    "linear-gradient(132deg, rgba(243, 23, 121, 0.80) 0.9%, rgba(121, 48, 217, 0.80) 66.21%, rgba(17, 0, 0, 0.80) 127.52%) padding-box, linear-gradient(to bottom right, #F31779, #7930D9, #51247a) border-box";

const sharedStyles = {
    background: AI_GRADIENT,
    border: "1px solid transparent",
    borderRadius: "8px",
    color: "#FFFFFF",
    flexShrink: 0,
    "& > svg": { color: "#FFFFFF" },
    "&:hover": { opacity: 0.85, background: AI_GRADIENT },
    "&.Mui-disabled": { opacity: 0.4, color: "#FFFFFF" }
};

export const StyledAiGradientIconButton = styled(StriimIconButton)<{ buttonSize?: number }>(({ buttonSize = 36 }) => ({
    ...sharedStyles,
    width: buttonSize,
    height: buttonSize
}));

export const StyledAiGradientTextButton = styled(Button)({
    ...sharedStyles,
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "0 16px",
    height: 36,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "0.5px",
    textTransform: "none",
    minWidth: "auto",
    boxShadow: "none"
});

export const aiButtonSxStyles = {
    position: "relative",
    height: "34px",
    border: "none",
    cursor: "pointer",
    borderRadius: "8px",
    gap: 1,
    background:
        "linear-gradient(132deg, rgba(243, 23, 121, 0.1) 0.9%, rgba(153, 77, 189, 0.1) 64.21%, rgba(37, 192, 230, 0.1) 127.52%)",
    zIndex: 1,
    padding: "4px 8px",
    "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        background:
            "linear-gradient(132deg, rgba(243, 23, 121, 0.8), rgba(153, 77, 189, 0.8), rgba(37, 192, 230, 0.8))",
        borderRadius: "inherit",
        zIndex: -1,
        mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        maskComposite: "exclude",
        WebkitMaskComposite: "destination-out",
        padding: "1px"
    }
};

export const aiButtonDisabledSxStyles = {
    position: "relative",
    height: "34px",
    border: "none",
    cursor: "not-allowed",
    opacity: 0.55,
    borderRadius: "8px",
    gap: 1,
    background:
        "linear-gradient(132deg, rgba(243, 23, 121, 0.05) 0.9%, rgba(153, 77, 189, 0.05) 64.21%, rgba(37, 192, 230, 0.05) 127.52%)",
    zIndex: 1,
    padding: "4px 8px",

    "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        background:
            "linear-gradient(132deg, rgba(200, 200, 200, 0.4), rgba(200, 200, 200, 0.4), rgba(200, 200, 200, 0.4))",
        borderRadius: "inherit",
        zIndex: -1,
        mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        maskComposite: "exclude",
        WebkitMaskComposite: "destination-out",
        padding: "1px",
        animation: "none",
        backgroundSize: "100% 100%"
    }
};
